// export let baseUrl="https://139.224.251.192/"

export let baseUrl="https://www.0shchess.ltd/"


